import {DiscountDialog, MarkupDialog} from '~/components/shared/Dialogs';
const AdjustmentDialogs = ({
  showDiscountDialog,
  setShowDiscountDialog,
  showMarkupDialog,
  setShowMarkupDialog,
  includeTaskId,
}) => (
  <>
    {showDiscountDialog && (
      <DiscountDialog
        task_id={includeTaskId ? showDiscountDialog.task_id : undefined}
        value={showDiscountDialog.discount}
        amount={showDiscountDialog.amount}
        onDismiss={() => setShowDiscountDialog(null)}
        onChange={showDiscountDialog.onChange}
      />
    )}
    {showMarkupDialog && (
      <MarkupDialog
        value={showMarkupDialog.markup}
        amount={showMarkupDialog.amount}
        onDismiss={() => setShowMarkupDialog(null)}
        onChange={showMarkupDialog.onChange}
      />
    )}
  </>
);
export default AdjustmentDialogs;
